export default {
  title: "المهام",
  routineTasks: "المهام الروتينية",
  oneTimeTasks: "المهام لمرة واحدة",
  reportedTasks: "المهام المبلغ عنها",
  manageRoutineTask: "إدارة المهمة الروتينية",
  createTask: "إنشاء مهمة",
  editTask: "تعديل مهمة",
  deleteTask: "حذف مهمة",
  taskDetails: "تفاصيل المهمة",
  taskName: "اسم المهمة",
  taskDescription: "وصف المهمة",
  taskStatus: "حالة المهمة",
  taskPriority: "أولوية المهمة",
  assignedTo: "مخصص لـ",
  dueDate: "تاريخ الاستحقاق",
  startDate: "تاريخ البدء",
  endDate: "تاريخ الانتهاء",
  createdAt: "تاريخ الإنشاء",
  updatedAt: "تاريخ التحديث",
  status: {
    pending: "معلقة",
    inProgress: "قيد التنفيذ",
    completed: "مكتملة",
    cancelled: "ملغاة",
    onHold: "معلقة",
  },
  priority: {
    low: "منخفضة",
    medium: "متوسطة",
    high: "عالية",
    urgent: "عاجلة",
  },
  actions: {
    view: "عرض المهمة",
    edit: "تعديل المهمة",
    delete: "حذف المهمة",
    complete: "إكمال المهمة",
    assign: "تعيين المهمة",
    comment: "إضافة تعليق",
    attach: "إرفاق ملف",
  },
  comments: {
    title: "التعليقات",
    addComment: "إضافة تعليق",
    noComments: "لا توجد تعليقات بعد",
    placeholder: "اكتب تعليقك هنا...",
  },
  attachments: {
    title: "المرفقات",
    addAttachment: "إضافة مرفق",
    noAttachments: "لا توجد مرفقات",
    download: "تحميل",
    delete: "حذف",
  },
  evaluation: {
    title: "التقييم",
    evaluate: "تقييم المهمة",
    rating: "التقييم",
    feedback: "التعليقات",
  },
  // RoutineTask.vue translations
  addMember: "اضافة عضو",
  email: "البريد الالكتروني",
  emailExistsError:
    "هذا البريد الالكتروني مسجل بالفعل. يرجى استخدام بريد الكتروني اخر.",
  generalError: "حدث خطأ في التقديم. يرجى المحاولة مرة اخرى في وقت لاحق.",
  invalidCompanyIdOrUserId: "معرف الشركة أو معرف المستخدم غير صحيح.",
  routineTaskDeleted: "تم حذف المهمة الروتينية بنجاح.",
  routineTaskAdded: "تم اضافة المهمة الروتينية بنجاح.",
  deleteConfirmationTitle: "حذف المهمة الروتينية",
  deleteConfirmationText: "هل تريد حذف هذه المهمة الروتينية؟",
  delete: "حذف",
  addRoutineTask: "اضافة مهمة روتينية",
  routineTaskName: "اسم المهمة الروتينية",
  description: "وصف المشروع",
  close: "اغلاق",
  create: "اضافة",
  routineTasksTable: "المهام الروتينية",
  routineTaskNameRequired: "يرجى ادخال اسم المهمة الروتينية.",
  routineTaskAddedError:
    "حدث خطأ في اضافة المهمة الروتينية. يرجى المحاولة مرة اخرى في وقت لاحق.",
  from: "من",
  to: "إلى",
  routineTaskManager: "مدير المهمة الروتينية",
  assignManager: "تعيين المدير",
  enterDescription: "ادخال الوصف",
  enterRoutineTaskName: "ادخال اسم المهمة الروتينية",
  createRoutineTask: "اضافة مهمة روتينية",
  saving: "يتم الحفظ...",
  noRoutineTasks: "لا يوجد مهام روتينية.",
  createee: "انشئ مهامك الروتينية",
  inactive: "غير نشط",
  active: "نشط",
  advancedSettings: "الإعدادات المتقدمة",
  taskNumber: "رقم المهمة",
  taskType: "نوع المهمة",
  selectTaskType: "اختر نوع المهمة",
  recurrentDays: "أيام التكرار",
  enterRecurrentDays: "ادخل عدد أيام التكرار",
  dayOfMonth: "يوم الشهر",
  enterDayOfMonth: "ادخل يوم الشهر مثل 1, 2,....31",
  department: "القسم",
  selectDepartment: "اختر القسم",
  sunday: "الاحد",
  monday: "الاثنين",
  tuesday: "الثلاثاء",
  wednesday: "الاربعاء",
  thursday: "الخميس",
  friday: "الجمعة",
  saturday: "السبت",
  enterStartDate: "ادخل تاريخ البدء",
  allStatuses: "جميع الحالات",
  allDepartments: "جميع الاقسام",
  allProjects: "جميع المشاريع",
  projectsSelected: "مشاريع محددة",
  weekly: "اسبوعي",
  monthly: "شهري",
  daily: "يومي",
  applyFilters: "تطبيق التصفيات",
  resetFilters: "اعادة تعيين التصفيات",
  selectAll: "اختر الكل",
  departmentsSelected: "اقسام محددة",
  done: "تم",
  not_done: "لم يتم",
  not_reported: "لم يتم التقرير",
  reported: "تم التقرير",
  notPaid: "غير مبلغ",
  LatedTasks: "مهام متاخرة",
  project: "المشروع",
  selectProject: "اختر المشروع",
  searchPlaceholder: "...ابحث هنا",
  allTypes: "جميع الأنواع",
  statusLabel: "الحالة",
  // RoutineTaskTable.vue translations
  tasksTable: "جدول المهام",
  edit: "تعديل",
  deleteConfirmationSuccess: "تم حذف المهمة بنجاح.",
  update: "تحديث",
  taskUpdatedSuccessfully: "تم تحديث المهمة بنجاح",
  taskDeletedSuccessfully: "تم حذف المهمة بنجاح",
  taskReportedSuccessfully: "تم تقرير المهمة بنجاح",
  taskCreatedBy: "تم الإنشاء بواسطة",
  log: "سجل",
  info: "معلومات",
  statusUpdatedSuccessfully: "تم تحديث الحالة بنجاح",
  errorUpdatingStatus: "حدث خطأ في تحديث الحالة",
  errorUpdatingTask: "حدث خطأ في تحديث المهمة",
  errorDeletingTask: "حدث خطأ في حذف المهمة",
  noLogsAvailable: "لا يوجد سجلات متاحة",
  changedTheField: "قام بتغيير الحقل",
  onDate: "في تاريخ",
  noTasks: "لا يوجد مهام.",
  taskStartDate: "تاريخ بدء المهمة",
  taskDeadline: "تاريخ انتهاء المهمة",
  deadline: "المهلة النهائية",
  reportTaskType: "تقرير المهمة",
  dayOfWeek: "يوم الاسبوع",
  fromTime: "من الوقت",
  taskCreatedSuccessfully: "تم انشاء المهمة بنجاح",
  taskCreatedSuccessfullyMessage: "تم انشاء المهمة بنجاح",
  taskCreationError: "حدث خطاء في انشاء المهمة",
  report: "تقرير",
  reportTask: "تقرير المهمة",
  selectReportTaskType: "حدد نوع المهمة",
  notes: "ملاحظات",
  enterNotes: "ادخل ملاحظات",
  employeeName: "اسم الموظف",
  taskFound: "هل يوجد مهمة",
  selectTaskFound: "حدد المهمة موجودة",
  criticalRoutineTasks: "المهام الحرجة",
};
